const BACKEND_ENDPOINT = 'http://localhost:8080/api';
export const WORKFLOW_ID = '5865b7e9-5326-49ab-a84b-641155571469';
export const DOCUMENT_ID = 'a0d4f6fb-3cae-4f4f-b10f-8b622f9a61af';

export default BACKEND_ENDPOINT;
